import React from 'react';
import { observer } from 'mobx-react-lite';
import { BetResponseCode, isMobile, notificationStore } from '@pascal/pascal-core';
import { AdditionalInputValueChangingButtons } from '@pascal/pascal-core/shared/core/enums/additionalInputValueChangingButtons';

import { doBetStore } from '../../store';
import { globalTranslationKeys } from '../../enums';
import { divide, toFixed } from '../../helpers/arithmeticOperations';
import { autoCashOutDataKeys, numPadSectionName } from '../../enums/uiConfig';

export const BetInputQuickButtons = observer(
  ({
    t,
    onBlur,
    limits,
    onChange,
    betAmount,
    autoBetData,
    fighterData,
    isAutoCashOut,
    autoCashOutOdd,
    showNotification,
    handleOpenNumPad,
    currentFighterSection,
    handleChangeInputValue,
    isValidatedAmountForManual,
    setIsValidatedAmountForManual,
  }) => {
    const changeAutoCashOutOdd = (betAmount) => {
      if (isAutoCashOut && autoCashOutOdd && autoCashOutOdd > divide(limits.maxWin, betAmount)) {
        doBetStore.updateAutoCashOutData(
          autoCashOutDataKeys.autoCashOutOdd,
          toFixed(divide(limits.maxWin, betAmount)),
          currentFighterSection
        );
        notificationStore.setNotificationType({
          responseCode: BetResponseCode.InValidMaxAutoCashOutOdd,
        });
      }
    };

    return (
      <div
        className={`bet-middle-container-wrapper ${
          autoBetData.isAutoBet ||
          fighterData.freeBetId ||
          autoBetData.autoBetCount ||
          fighterData.isNextRoundBet
            ? 'disabled'
            : ''
        }`}
      >
        <div className='middle-top-row'>
          {/* ADD CLASS " disabled " */}
          <div className='middle-button-container'>
            <div
              className='middle-bet-button'
              onClick={() => handleChangeInputValue(AdditionalInputValueChangingButtons.divide)}
            >
              <span className='text-middle-bet-button'>1/2</span>
            </div>
          </div>
          <div className='container-middle-input'>
            <div className='container-middle-input-inner'>
              {/* ADD CLASS " disabled " */}
              <div
                className='for-minus-box'
                onClick={() => handleChangeInputValue(AdditionalInputValueChangingButtons.minus)}
              >
                <i className='ui-lib-minus input-icons' />
              </div>
              <div className='mid-input-cont'>
                <input
                  className='mid-bet-input'
                  type='text'
                  maxLength={9}
                  readOnly={isMobile()}
                  inputMode={isMobile() ? 'none' : 'text'}
                  autoComplete='off'
                  title={`${betAmount || ''}`}
                  value={betAmount || ''}
                  onMouseUp={() => {
                    if (isValidatedAmountForManual) {
                      setIsValidatedAmountForManual(false);
                    }
                  }}
                  onBlur={() => {
                    const { validatedBetAmount, errorMessageCode } = onBlur(betAmount);
                    if (errorMessageCode) {
                      showNotification({ responseCode: errorMessageCode });
                      setIsValidatedAmountForManual(true);
                      setTimeout(() => setIsValidatedAmountForManual(false), 200);
                    }
                    onChange(validatedBetAmount);
                    changeAutoCashOutOdd(validatedBetAmount);
                  }}
                  onChange={(e) => {
                    if (
                      /^([0]{1}|([1-9]{1}\d*))(?:\.\d{0,2})?$/.test(e.target.value) ||
                      e.target.value === ''
                    ) {
                      return onChange(e.target.value);
                    }
                  }}
                  {...(isMobile()
                    ? { onClick: (e) => handleOpenNumPad(e, numPadSectionName.manual) }
                    : {})}
                />
              </div>
              {/* ADD CLASS " disabled " */}
              <div
                className='for-plus-box'
                onClick={() => handleChangeInputValue(AdditionalInputValueChangingButtons.plus)}
              >
                <i className='ui-lib-plus input-icons' />
              </div>
            </div>
          </div>
          <div className='middle-button-container'>
            <div
              className='middle-bet-button'
              onClick={() => handleChangeInputValue(AdditionalInputValueChangingButtons.multiply)}
            >
              <span className='text-middle-bet-button'>x2</span>
            </div>
          </div>
        </div>
        <div className='bottom-buttons-row'>
          {/* ADD CLASS " disabled " */}
          <div className={`bottom-buttons-boxes ${betAmount === limits.minBet ? 'disabled' : ''}`}>
            <div
              className='bottom-buttons-boxes-inner'
              onClick={() => handleChangeInputValue(AdditionalInputValueChangingButtons.min)}
            >
              <span className='text-middle-bet-button'>{t(globalTranslationKeys.Min)}</span>
            </div>
          </div>
          {/* ADD CLASS " disabled " */}
          <div className={`bottom-buttons-boxes ${betAmount === limits.maxBet ? 'disabled' : ''}`}>
            <div
              className='bottom-buttons-boxes-inner'
              onClick={() => handleChangeInputValue(AdditionalInputValueChangingButtons.max)}
            >
              <span className='text-middle-bet-button'>{t(globalTranslationKeys.Max)}</span>
            </div>
          </div>
          {/* ADD CLASS " disabled " */}
          <div className='bottom-buttons-boxes'>
            <div
              className='bottom-buttons-boxes-inner'
              onClick={() => handleChangeInputValue(AdditionalInputValueChangingButtons.allIn)}
            >
              <span className='text-middle-bet-button'>{t(globalTranslationKeys.AllIn)}</span>
            </div>
          </div>
          {/* ADD CLASS " disabled " */}
          <div className='bottom-buttons-boxes'>
            <div
              className='bottom-buttons-boxes-inner'
              onClick={() => {
                if (isAutoCashOut) {
                  doBetStore.updateAutoCashOutData(
                    autoCashOutDataKeys.isOpened,
                    !doBetStore.autoCashOutData[currentFighterSection].isOpened,
                    currentFighterSection
                  );
                }
                handleChangeInputValue(AdditionalInputValueChangingButtons.min);
              }}
            >
              <i className='ui-lib-time-over bottom-button-icon' />
            </div>
          </div>
        </div>
      </div>
    );
  }
);
